/* IMPORT */
import change from './change.js';
/* MAIN */
const grayscale = (color) => {
    return change(color, { s: 0 });
};
/* EXPORT */
export default grayscale;
